var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plugin-layout',[_c('div',[_c('plugin-editions',{attrs:{"plugin":_vm.plugin}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }